module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Bookmark-8ed377c2a5786332d5b216b12a809f7a.svg";